import { useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'event',
    viewPath: props.viewPath,
  })

  return function onClick(event) {
    event.preventDefault()
    change(next => {
      next.selected.showInfoDialog = true
      next.selected.showActionsDialog = false
    })
  }
}

export function useOnContextMenu(props) {
  let change = useDataChange({
    context: 'event',
    viewPath: props.viewPath,
  })

  return function onContextMenu(event) {
    event.preventDefault()
    change(next => {
      next.selected.showInfoDialog = false
      next.selected.showActionsDialog = true
    })
  }
}

export function getAppointmentTypeColor(event) {
  return event.appointment_type_color
}

/**
 *
 * @param {number} slot_interval
 * @param {number} appointment_duration
 * @returns {boolean}
 */
export function isCompactView(slot_interval, appointment_duration) {
  return appointment_duration <= 3 * slot_interval
}
